import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { Subject } from 'rxjs';
import { Alert } from '../../../../../shared/cw-backend/models/backend-definitions.module';

@Component({
    selector: 'app-alert-modal',
    templateUrl: './alert-modal.component.html',
    styleUrls: ['./alert-modal.component.scss'],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None
})
export class AlertModalComponent implements OnInit, OnDestroy {

    alert : string;

    public seconds: number = 30;
    private interval: any;

    private _unsubscribeAll: Subject<any>;
    constructor(
        public _matDialogRef: MatDialogRef<AlertModalComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: string
    ) {
        this._unsubscribeAll = new Subject();
    }
    ngOnDestroy(): void {
        this.dimiss(); 
        this._unsubscribeAll.next(true);
        this._unsubscribeAll.complete();
    }

    ngOnInit() {

        this.alert = this._data;
        let teste = document.getElementById('info');
        teste.insertAdjacentHTML('beforeend', this.alert);
        this.startCountdown();

    }

    
    private startCountdown(): void {
        const endDate = new Date();
        endDate.setSeconds(endDate.getSeconds() + this.seconds);
    
        this.interval = setInterval(() => {
          const now = new Date();
          const difference = endDate.getTime() - now.getTime();
    
          if (difference <= 0) {
            clearInterval(this.interval);
            this.dimiss();
            this.seconds = 0;
            return;
          }
    
          this.seconds = Math.floor((difference % (1000 * 60)) / 1000);
        }, 1000);
      }
    


    dimiss() {
        let teste = document.getElementById('info');
        if(teste){
            teste.innerHTML = "";
        }
        this.seconds  = 0
        this.alert = null;
        this._matDialogRef.close();
       
    }

}
